export default __webpack_public_path__ + "static/media/CRS_7131-HDR-min.82fae842.jpg";